import { FC } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { AttendanceByCompanyItem } from "src/apis/dashboardAttendance";
import ChartCard from "./ChartCard";
import { STATUS_COLORS } from "./constants";

type AttendanceByCompanyChartProps = {
  data: AttendanceByCompanyItem[];
};

const AttendanceByCompanyChart: FC<AttendanceByCompanyChartProps> = ({
  data,
}): JSX.Element => {
  const chartData = data
    .slice(0, 15)
    .map((item) => ({ ...item, name: item.company_name ?? "—" }));

  return (
    <ChartCard title="Atendimentos por empresa" isEmpty={chartData.length === 0}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData} margin={{ top: 8, right: 16, bottom: 0, left: -16 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" fontSize={11} interval={0} angle={-15} textAnchor="end" height={60} />
          <YAxis allowDecimals={false} fontSize={12} />
          <Tooltip />
          <Bar dataKey="total" name="Total" fill={STATUS_COLORS.scheduled} radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
};

export default AttendanceByCompanyChart;
